import React from 'react';
import { formatKpi, Kpi } from '@utils/Formatters';
import { renderLoading } from '@pages/Loading';
import * as styles from '@pages/product-analyzer/overview/Overview.module.scss';
import { charts } from '@ecosystem/newron-design-system';
import { OverviewKpi, OverviewKpiTitle } from '@models/Products';

interface ProductsOverviewDoughnutContainerProps {
  overviewKpi: OverviewKpi;
  isLoading: boolean;
  currencySymbol: string;
}

const renderDoughnut = (overviewKpi: OverviewKpi, isLoading: boolean, currencySymbol: string) => {
  const { DoughnutChart } = charts;

  if (isLoading) {
    return renderLoading();
  }

  let values = overviewKpi.items.map((item) => {
    const itemName = item.item.itemName;
    const brandName = item.item.itemBrand;
    const marketRevenuePercentage = item.marketShareRevenue.sharePercentage;

    const marketRevenue = formatKpi(Kpi.marketRevenue, item.marketRevenue.value, {
      currencySymbol: currencySymbol,
    });

    return {
      value: marketRevenuePercentage,
      label: `${brandName}`,
      tooltipData: [
        {
          label: `${brandName} ${itemName} > ${marketRevenue}`,
          value: marketRevenuePercentage,
        },
      ],
    };
  });

  const restOfMarketRevenue = formatKpi(Kpi.marketRevenue, overviewKpi.restOfMarketRevenue, {
    currencySymbol: currencySymbol,
  });

  values.push({
    value: 100 - overviewKpi.topItemsRevenuePercentage,
    label: `Others`,
    tooltipData: [
      {
        label: `${OverviewKpiTitle.restOfMarketRevenue} > ${restOfMarketRevenue}`,
        value: 100 - overviewKpi.topItemsRevenuePercentage,
      },
    ],
  });

  return (
    <div className={styles.Overview__Doughnut}>
      <DoughnutChart
        data={values}
        primaryLabel={`${formatKpi(Kpi.marketShareRevenue, overviewKpi.topItemsRevenuePercentage)}`}
        secondaryLabel={`${overviewKpi.items.length} products`}
        width={270}
        height={220}
        minWidth={270}
        minHeight={220}
        isSegmentLabelVisible={false}
        tooltipProps={{
          valueFormat: (value) => `${value}%`,
          showHeader: false,
        }}
      />
    </div>
  );
};

const ProductsOverviewDoughnutContainer: React.FC<ProductsOverviewDoughnutContainerProps> = ({
  overviewKpi,
  isLoading,
  currencySymbol,
}) => {
  return renderDoughnut(overviewKpi, isLoading, currencySymbol);
};

export default ProductsOverviewDoughnutContainer;
